import moment from 'moment';

import Storage from '../helpers/Storage.js';

const today = moment();

export default {
  config: {
    method: "payments/",
    title: "Заявки на возмещение",
    objectName: "Заявка на возмещение",
  },
  properties: {
    id: {
      default: false,
      type: "text",
      title: "#",
      preset: true,
      width: "80px",
    },
    created_at: {
      default: "",
      type: "datetime",
      title: "Создан",
      preset: true,
    },
    updated_at: {
      default: "",
      type: "datetime",
      title: "Обновлен",
      preset: true,
    },
    user: {
      default: "",
      type: "object",
      title: "Пользователь",
      width: "250px",
      preset: true,
    },
    amount: {
      default: "",
      type: "number",
      title: "Сумма оплаты",
      width: "250px",
      modifyCondition: (object) => Storage.getData('user')?.admin || (moment(object.created_at).year >= today.year && moment(object.created_at).month >= today.month),
    },
    file: {
      default: "",
      type: "file",
      title: "Квитанция",
      width: false,
      showCondition: (object) => !(object?.id),
    },
    file_url: {
      default: "",
      type: "link",
      title: "Квитанция",
      preset: true,
      width: "auto",
    },
  }
};
